// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ex-3";
export var flatBottomCorners = "_ex-5";
export var productImage = "_ex-0";
export var quantityContainer = "_ex-2";
export var quantityHeader = "_ex-6";
export var tooltip = "_ex-1";
export var wrapAndEllipsesOverflow = "_ex-4";